import { render } from "./AccountOrders.vue?vue&type=template&id=12db097f"
import script from "./AccountOrders.vue?vue&type=script&lang=js"
export * from "./AccountOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__